import React from "react";
import Footer from "./Footer";
import Header from "../header/Header";
import SideBar from "./SideBar";
import {
  getError,
  getGoogleLoginStatus,
  getStatus,
} from "../../../redux/slice/userSlice";
import { useSelector } from "react-redux";
import Loading from "../../common/Loading";
import AlertBox from "../../common/AlertBox";

const HomeLayout = ({ children }) => {
  const status = useSelector(getStatus);
  const error = useSelector(getError);

  const googleStatus = useSelector(getGoogleLoginStatus);

  return (
    <div className="sm:p-6 sm:pb-3 p-3 bg-backgroundPrimary min-h-[100vh] flex-col flex">
      {status === "loading" || googleStatus === "loading" ? <Loading /> : null}
      {status === "failed" ? <AlertBox type={status} message={error} /> : null}

      <Header />
      <div className="flex flex-row gap-14 sm:py-10 py-5">
        <div className="sm:block hidden">
          <SideBar />
        </div>
        <main className="flex flex-col sm:p-8 p-5 bg-primary rounded-[10px] border border-gray-300 shadow-md w-full">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default HomeLayout;
